import { validateValidShippingPrice } from './validate-valid-shipping-price';

const errors = {
    noShipping: 'syi_validation_shipping_no_shipping',
    empty: 'syi_validation_shipping_enter_method_and_cost',
    invalid: 'syi_validation_shipping_method_invalid',
    duplicate: 'syi_validation_shipping_method_identical',
    weight: 'syi_validation_shipping_enter_weight'
};

export function validate(newState) {
    if (!newState.offerTakeaway && !newState.offerShipping) {
        newState.globalValidationError = errors.noShipping;
        newState.validationErrors = {
            global: errors.noShipping
        };
        return newState;
    }

    newState.globalValidationError = null;

    const validateProviders = providers => {
        let hasAnyNonValidOption = false;
        let hasAnyValidOption = false;
        let weightIsInvalid = false;
        providers.forEach(provider => {
            provider.products.forEach(product => {
                if (!product.selected || !newState.offerShipping) {
                    // Not selected, set to valid without error
                    product.isValid = true;
                    product.validationError = null;
                    product.isWeightValid = true;
                    product.weightValidationError = null;
                } else {
                    const errorMessage = validateValidShippingPrice(
                        product,
                        provider.useAdvancedWidget
                    );
                    if (errorMessage) {
                        product.isValid = false;
                        product.validationError = errorMessage;
                        hasAnyNonValidOption = true;
                    } else {
                        product.isValid = true;
                        product.validationError = null;
                        hasAnyValidOption = true;
                    }
                    if (provider.useAdvancedWidget && !product.productId) {
                        product.isWeightValid = false;
                        product.weightValidationError = errors.weight;
                        weightIsInvalid = true;
                    } else {
                        product.isWeightValid = true;
                        product.weightValidationError = null;
                    }
                }
            });
        });
        return { hasAnyNonValidOption, hasAnyValidOption, weightIsInvalid };
    };

    const primaryValidations = validateProviders(
        newState.primaryShippingProviders
    );
    const secondaryValidations = validateProviders(
        newState.secondaryShippingProviders
    );

    const getFirstValidationError = ({
        hasAnyNonValidOption,
        weightIsInvalid,
        hasAnyValidOption
    }) => {
        if (hasAnyNonValidOption) {
            return errors.invalid;
        }
        if (weightIsInvalid) {
            return errors.weight;
        }
        if (!hasAnyValidOption) {
            return errors.empty;
        }
        return null;
    };

    const getDuplicateError = () => {
        if (
            newState.selectedShippingOptions.length > 1 &&
            JSON.stringify(newState.selectedShippingOptions[0]) ===
                JSON.stringify(newState.selectedShippingOptions[1])
        ) {
            return errors.duplicate;
        }
        return null;
    };

    newState.primaryValidationError = newState.offerShipping
        ? getFirstValidationError(primaryValidations)
        : null;
    newState.secondaryValidationError =
        newState.offerShipping && newState.secondaryShippingOptionOpen
            ? getFirstValidationError(secondaryValidations) ||
              getDuplicateError()
            : null;

    const validationErrors = {};
    if (newState.primaryValidationError)
        validationErrors.primary = newState.primaryValidationError;
    if (newState.secondaryValidationError)
        validationErrors.secondary = newState.secondaryValidationError;
    newState.validationErrors = validationErrors;

    return newState;
}
